import React, { useState } from 'react';
import { TrendingUp, AlertCircle } from 'lucide-react';
export function SerotoninGraph() {
  const [showLyraSleep, setShowLyraSleep] = useState(false);
  return <div className="my-16 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 md:p-12 border border-blue-200" data-id="element-390">
      <div className="text-center mb-8" data-id="element-391">
        <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-392">
          The Serotonin Problem Most Sleep Aids Miss
        </h3>
        <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-393">
          Low serotonin is the hidden cause of insomnia. Most sleep aids ignore
          it. LyraSleep's 5-HTP directly supports serotonin production for
          natural, lasting sleep.
        </p>
      </div>

      {/* Toggle Button */}
      <div className="flex justify-center mb-8" data-id="element-394">
        <div className="inline-flex rounded-full bg-white p-1 shadow-lg" data-id="element-395">
          <button onClick={() => setShowLyraSleep(false)} className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${!showLyraSleep ? 'bg-red-500 text-white shadow-md' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-396">
            Without LyraSleep
          </button>
          <button onClick={() => setShowLyraSleep(true)} className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${showLyraSleep ? 'bg-green-500 text-white shadow-md' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-397">
            With LyraSleep
          </button>
        </div>
      </div>

      {/* Graph Container */}
      <div className="bg-white rounded-xl p-6 md:p-8 shadow-xl" data-id="element-398">
        <div className="relative h-80" data-id="element-399">
          {/* Y-axis labels */}
          <div className="absolute left-0 top-0 bottom-0 flex flex-col justify-between text-xs text-gray-600 pr-2" data-id="element-400">
            <span data-id="element-401">High</span>
            <span data-id="element-402">Normal</span>
            <span data-id="element-403">Low</span>
          </div>

          {/* Graph area */}
          <div className="ml-12 h-full relative" data-id="element-404">
            {/* Grid lines */}
            <div className="absolute inset-0 flex flex-col justify-between" data-id="element-405">
              <div className="border-t border-gray-200" data-id="element-406"></div>
              <div className="border-t border-gray-300 border-dashed" data-id="element-407"></div>
              <div className="border-t border-gray-200" data-id="element-408"></div>
            </div>

            {/* Normal range indicator */}
            <div className="absolute left-0 right-0 top-[25%] h-[25%] bg-green-100 opacity-30 rounded" data-id="element-409">
              <span className="absolute right-2 top-1 text-xs text-green-700 font-semibold" data-id="element-410">
                Healthy Range
              </span>
            </div>

            {/* Time labels */}
            <div className="absolute bottom-0 left-0 right-0 flex justify-between text-xs text-gray-600 pt-2" data-id="element-411">
              <span data-id="element-412">Evening</span>
              <span data-id="element-413">Night</span>
              <span data-id="element-414">Morning</span>
            </div>

            {/* Without LyraSleep - Low Serotonin Line */}
            <svg className={`absolute inset-0 transition-opacity duration-500 ${showLyraSleep ? 'opacity-30' : 'opacity-100'}`} viewBox="0 0 400 280" preserveAspectRatio="none" data-id="element-415">
              <path d="M 0 200 Q 100 220, 200 210 T 400 230" fill="none" stroke="#ef4444" strokeWidth="4" strokeLinecap="round" data-id="element-416" />
              {/* Dots */}
              <circle cx="0" cy="200" r="6" fill="#ef4444" data-id="element-417" />
              <circle cx="200" cy="210" r="6" fill="#ef4444" data-id="element-418" />
              <circle cx="400" cy="230" r="6" fill="#ef4444" data-id="element-419" />
            </svg>

            {/* With LyraSleep - Healthy Serotonin Line */}
            <svg className={`absolute inset-0 transition-opacity duration-500 ${showLyraSleep ? 'opacity-100' : 'opacity-0'}`} viewBox="0 0 400 280" preserveAspectRatio="none" data-id="element-420">
              <path d="M 0 200 Q 100 120, 200 100 T 400 90" fill="none" stroke="#22c55e" strokeWidth="4" strokeLinecap="round" data-id="element-421" />
              {/* Dots */}
              <circle cx="0" cy="200" r="6" fill="#22c55e" data-id="element-422" />
              <circle cx="200" cy="100" r="6" fill="#22c55e" data-id="element-423" />
              <circle cx="400" cy="90" r="6" fill="#22c55e" data-id="element-424" />
            </svg>

            {/* Annotations */}
            {!showLyraSleep && <div className="absolute top-[55%] left-1/2 transform -translate-x-1/2" data-id="element-425">
                <div className="bg-red-100 border-2 border-red-500 rounded-lg px-4 py-2 shadow-lg animate-fade-in" data-id="element-426">
                  <div className="flex items-center gap-2" data-id="element-427">
                    <AlertCircle className="w-5 h-5 text-red-600" data-id="element-428" />
                    <div data-id="element-429">
                      <p className="text-sm font-bold text-red-900" data-id="element-430">
                        Low Serotonin
                      </p>
                      <p className="text-xs text-red-700" data-id="element-431">
                        Racing thoughts, anxiety, can't sleep
                      </p>
                    </div>
                  </div>
                </div>
              </div>}

            {showLyraSleep && <div className="absolute top-[20%] left-1/2 transform -translate-x-1/2" data-id="element-432">
                <div className="bg-green-100 border-2 border-green-500 rounded-lg px-4 py-2 shadow-lg animate-fade-in" data-id="element-433">
                  <div className="flex items-center gap-2" data-id="element-434">
                    <TrendingUp className="w-5 h-5 text-green-600" data-id="element-435" />
                    <div data-id="element-436">
                      <p className="text-sm font-bold text-green-900" data-id="element-437">
                        Healthy Serotonin
                      </p>
                      <p className="text-xs text-green-700" data-id="element-438">
                        Calm mind, natural sleep, wake refreshed
                      </p>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>

        {/* Legend */}
        <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-439">
          <div className="flex flex-wrap justify-center gap-6" data-id="element-440">
            <div className="flex items-center gap-2" data-id="element-441">
              <div className="w-4 h-4 bg-red-500 rounded-full" data-id="element-442"></div>
              <span className="text-sm text-gray-700" data-id="element-443">
                Without LyraSleep (Low Serotonin)
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-444">
              <div className="w-4 h-4 bg-green-500 rounded-full" data-id="element-445"></div>
              <span className="text-sm text-gray-700" data-id="element-446">
                With LyraSleep (Healthy Serotonin)
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Explanation Cards */}
      <div className="grid md:grid-cols-2 gap-6 mt-8" data-id="element-447">
        <div className="bg-white rounded-xl p-6 shadow-lg border-2 border-red-200" data-id="element-448">
          <div className="flex items-start gap-3 mb-3" data-id="element-449">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0" data-id="element-450">
              <AlertCircle className="w-6 h-6 text-red-600" data-id="element-451" />
            </div>
            <div data-id="element-452">
              <h4 className="font-bold text-gray-900 mb-1" data-id="element-453">The Problem</h4>
              <p className="text-sm text-gray-700" data-id="element-454">
                Low serotonin = racing thoughts, anxiety, and insomnia. Most
                sleep aids ignore this root cause.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-lg border-2 border-green-200" data-id="element-455">
          <div className="flex items-start gap-3 mb-3" data-id="element-456">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-457">
              <TrendingUp className="w-6 h-6 text-green-600" data-id="element-458" />
            </div>
            <div data-id="element-459">
              <h4 className="font-bold text-gray-900 mb-1" data-id="element-460">The Solution</h4>
              <p className="text-sm text-gray-700" data-id="element-461">
                LyraSleep's 5-HTP supports natural serotonin production, calming
                your mind for deep, restorative sleep.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Note */}
      <div className="mt-6 text-center" data-id="element-462">
        <p className="text-sm text-gray-600 italic" data-id="element-463">
          Click the buttons above to see how LyraSleep restores healthy
          serotonin levels
        </p>
      </div>
    </div>;
}